function formatBuildTime(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return iso;
  }

  return new Intl.DateTimeFormat('id-ID', {
    timeZone: 'Asia/Jakarta',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(date);
}

export function getAppVersion() {
  return {
    version: typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '1.1.0',
    buildTime: typeof __APP_BUILD__ !== 'undefined' ? __APP_BUILD__ : '',
  };
}

export default function AppVersion({ className = '' }: { className?: string }) {
  const { version, buildTime } = getAppVersion();
  const builtAt = buildTime ? formatBuildTime(buildTime) : '';

  return (
    <p className={`text-[11px] leading-4 text-gray-400 dark:text-gray-500 ${className}`}>
      v{version}
      {builtAt ? ` · ${builtAt} WIB` : ''}
    </p>
  );
}
